import { PreviewMode } from 'services/Store/Project/enums'
import { testPropsEl } from 'utils/test/qaData'

import type { ButtonElementType } from '../buttonTypes'
import { getCorrectLink } from '../helper'
import BaseButtonElementStyled from '../styled/BaseButtonElementStyled'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const LinkButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  styles,
  mode,
  font,
  children,
}) => {
  const label = element?.value?.label
  const actionData = element?.value?.actionData
  const isEditorMode = mode.previewMode === PreviewMode.editor
  const { target, url } = getCorrectLink(actionData, isEditorMode)

  return (
    <BaseButtonElementStyled
      {...testPropsEl('courseButton', { value: actionData }, { label })}
      $fonts={font}
      $styles={styles}
      aria-label={label}
      as='a'
      href={url}
      rel='noreferrer'
      target={target}
    >
      {children || label}
    </BaseButtonElementStyled>
  )
}

export default LinkButtonElement
